import React from "react";

const reviews = [
    {
        id: 1,
        iframe: (
            <div className="slick-review">
                <iframe
                    id="gdm-vp-snippet-quotations_9901242b-7deb-4436-a45b-5c4977e06a95"
                    src="https://datainsights-cdn.dm.aws.gartner.com/vp/snippet/9901242b-7deb-4436-a45b-5c4977e06a95"
                    frameBorder={0}
                    style={{
                        width: '100%',
                        overflow: 'hidden'
                    }}
                    scrolling="no"
                    height="100%"
                />
            </div>
        )
    },
    {
        id: 2,
        iframe: (
            <div className="slick-review">
                <iframe
                    id="gdm-vp-snippet-quotations_b5cb06f0-32c6-4ef7-9ce7-55e389d2c215"
                    src="https://datainsights-cdn.dm.aws.gartner.com/vp/snippet/b5cb06f0-32c6-4ef7-9ce7-55e389d2c215"
                    frameBorder={0}
                    style={{
                        width: '100%',
                        overflow: 'hidden'
                    }}
                    scrolling="no"
                    height="100%"
                />
            </div>
        )
    },
    {
        id: 3,
        iframe: (
            <div className="slick-review">
                <iframe
                    id="gdm-vp-snippet-quotations_1ab5d733-991a-4e00-a50f-c585d02a46d1"
                    src="https://datainsights-cdn.dm.aws.gartner.com/vp/snippet/1ab5d733-991a-4e00-a50f-c585d02a46d1"
                    frameBorder={0}
                    style={{
                        width: '100%',
                        overflow: 'hidden'
                    }}
                    scrolling="no"
                    height="100%"
                />
            </div>
        )
    },
    {
        id: 4,
        iframe: (
            <div className="slick-review">
                <iframe
                    id="gdm-vp-snippet-quotations_9cb56b45-a3ec-44d2-bfd3-be3da69390d3"
                    src="https://datainsights-cdn.dm.aws.gartner.com/vp/snippet/9cb56b45-a3ec-44d2-bfd3-be3da69390d3"
                    frameBorder={0}
                    style={{
                        width: '100%',
                        overflow: 'hidden'
                    }}
                    scrolling="no"
                    height="100%"
                />
            </div>
        )
    },
]

export default reviews
